import React, { useEffect, useState, useRef } from "react";
import "../../assets/css/inbox.css";
import "../../assets/css/responsive.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Avatar from "../../assets/images/avatar.svg";
import Alert from "../../assets/images/alert-circle.svg";
import Download from "../../assets/images/download.svg";
import Trash from "../../assets/images/trash.svg";
import filetext from "../../assets/images/file-text 2.svg";
import Contact from "../../assets/images/contact2.svg";
import Call from "../../assets/images/call.svg";
import Msg from "../../assets/images/msg.svg";
import Mail from "../../assets/images/mail.svg";
import Send from "../../assets/images/send.svg";
import Archive from "../../assets/images/Archive.svg";
import RedAlert from "../../assets/images/red-alert.png";
import AvenuChatbot from "../../assets/images/AvenuChatbot.svg";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { API } from "../../config/api";
import arrowup from "../../assets/images/arrow-up.png";
import downarrow from "../../assets/images/down.png";
import { ApiHelper } from "../../helpers/ApiHelper";
import Messageicon from "../../assets/images/message-g-icon.png";
import Add from "../../assets/images/add.svg";
import Close from "../../assets/images/X.svg";
import Search from "../../assets/images/Search.svg";
import Spinner from "../../components/Spinner";
import MiniSpinner from "../../components/MiniSpinner";
import sdot from "../../assets/images/sdot.svg";
import File from "../../assets/images/file.svg";
import Folder from "../../assets/images/folder.svg";
import Addnow from "../../assets/images/plus-circle.png";
import sample from "../../assets/images/samplefile.png";
import Alerts from "../../assets/images/alert-triangle.svg";
import Successful from "../../assets/images/success.svg";
import Pending from "../../assets/images/pending.svg";
import Modal from "react-modal";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { useNavigate } from "react-router";
import Form from "react-bootstrap/Form";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Delete, Edit, TramSharp } from "@material-ui/icons";
import closex from "../../assets/images/X.svg";
import Serachg from "../../assets/images/Search-Icon-grey.svg";
import tagAdd from "../../assets/images/plus-circle.png";
import Grouplogo from "../../assets/images/chat-logo.png";
import Editic from "../../assets/images/edit_ic.svg";
import UserChecked from "../../assets/images/user-check 2.svg";
import NotSend from "../../assets/images/not-send.svg";
import documentimage from "../../assets/images/file-plus.svg";
import pauseimage from "../../assets/images/pause-circle 1.svg";
import onboardingimage from "../../assets/images/status1.svg";
import rejectimage from "../../assets/images/status3.svg";
import Menu from "../../assets/images/menu.svg";
import resumeimage from "../../assets/images/resume.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { width } from "@material-ui/system";
import { end } from "@popperjs/core";
import downarrows from "../../assets/images/dropdown.svg";
import caseimg from "../../assets/images/caseimg.svg";
import caselogo from "../../assets/images/caselogo.png";

// import ModalAlert from "https://cdn.skypack.dev/react-modal@3.16.1";

const Everify = () => {
  const [loader, setLoader] = useState(false);
  const [cases, setCases] = useState([]);
  const [caseDetails, setCaseDetails] = useState(null);
  const [pageNo, setPageNo] = useState(1);

  const [miniLoader, setMiniLoader] = useState(false);
  const navigate = useNavigate();
  const [applicants, setApplicants] = useState([]);
  const [chatbotsAnwers, setChatbotsAnwers] = useState([]);
  const [status, setStatus] = useState("");
  const [tags, setTags] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [istag, isSetTag] = useState(false);
  const [comment, setComments] = useState([]);
  const [editComment, setEditComment] = useState(false);
  const [filterState, setFilterState] = useState("hire");
  const [jobs, setJobs] = useState([]);
  const [filterJob, setFilterJob] = useState(0);
  const [filterCompany, setFilterCompany] = useState(null);
  const [filterDate, setFilterDate] = useState("");
  const [addCandidateOpen, setAddCandidateOpen] = useState(false);
  const [candidateJobId, setCandidateJobId] = useState(null);
  const [candidateJobName, setCandidateJobName] = useState("");
  const [candidateFirstName, setCandidateFirstname] = useState("");
  const [candidateLastName, setCandidateLastname] = useState("");
  const [candidateEmail, setCandidateEmail] = useState("");
  const [candidatePhone, setCandidatePhone] = useState("");
  const [error, setError] = useState(false);
  const [offset, setOffset] = useState(0);
  const [onBorardingStatus, setOnBoardingStatus] = useState([]);
  const [applicationHistory, setApplicationHistory] = useState([]);
  const [index, setIndex] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [userId, setUserId] = useState("");
  const [formErr, setFormErr] = useState(false);
  const [phoneErr, setPhoneErr] = useState(false);
  const [phoneExist, setPhoneExist] = useState(false);
  const [statusOptions, setStatusOptions] = useState([
    {
      id: 1,
      label: "Onboarding",
      value: "onboarding",
    },
    {
      id: 2,
      label: "Pause",
      value: "paused",
    },
    {
      id: 3,
      label: "Archive",
      value: "archive",
    },
    // {
    //   id: 4,
    //   label: "My Team",
    //   value: "myteam",
    // },
    {
      id: 5,
      label: "Cancel",
      value: "rejected",
    },
  ]);
  const [candidateIdList, setCandidateIdList] = useState([]);
  const [currentStatus, setCurrentStatus] = useState("default");
  const [showAlert, setShowAlert] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [documents, setDocuments] = useState([]);
  const [doc, setDoc] = useState("");
  const [usersLength, setUsersLength] = useState(null);
  const [emailError, setEmailError] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isUpload, setIsUpload] = useState(false);
  const [message, setMessage] = useState("");
  const [rsTab, setRsTab] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [deletePopupData, setDeletePopupData] = useState();
  const [documentType, setDocumentType] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [mailStatus, setMailStatus] = useState(true);
  const [company, setCompany] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [archiveModal, setArchiveModal] = useState(false);
  const [onClickToggle, setOnClickToggle] = useState(false);
  const [onClickIndex, setOnClickIndex] = useState(null);
  const [onClickHistoryToggle, setOnClickHistoryToggle] = useState(false);
  const [onClickHistoryIndex, setOnClickHistoryIndex] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  // const [method, setMethod]=useState('');
  const fileInputRef = useRef(null);
  const [editName, setEditName] = useState(false);
  const [editPhone, setEditPhone] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [reportName, setReportName] = useState("");
  const [reportPhone, setReportPhone] = useState("");
  const [reportEmail, setReportEmail] = useState("");
  const [isMyteam, setIsMyteam] = useState(false);
  const [messages, setMessages] = useState([]);
  const [textMessage, setTextMessage] = useState("");
  const [messageCount, setMessageCount] = useState([]);
  const lastMessageRef = useRef(null);
  const prevMessagesRef = useRef([]);
  const candidateDetails = useRef(null);
  const [isConversationModalOpen, setIsConversationModalOpen] = useState(false);
  const [conversationModalData, setConversationModalData] = useState(null);
  const [isMultipleChangeModalOpen, setIsMultipleChangeModalOpen] =
    useState(false);
  const [isMultipleArchiveModalOpen, setIsMultipleArchiveModalOpen] =
    useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [listA, setListA] = useState([]);
  const [listB, setListB] = useState([]);
  const [listC, setListC] = useState([]);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "45%",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };

  useEffect(() => {
    setPageNo(1);
    fetchAllCases();
  }, []);

  useEffect(() => {
    setPageNo(1);
    fetchAllCases();
  }, [filterCompany]);

  useEffect(() => {
    if (caseDetails?.citizenship_status_code !== undefined) getListValues();
  }, [caseDetails]);

  const getListValues = async () => {
    // console.log(data);
    setLoader(true);
    await ApiHelper.post(API.getI9DocTypes, {
      citizenship_status_code: caseDetails?.citizenship_status_code,
      // document_category: "LIST_A",
    }).then((res) => {
      console.log(res);
      setListA(res?.data?.ListA?.document_types);
      // });
      // setLoader(true);
      // await ApiHelper.post(API.getI9DocTypes, {
      //   citizenship_status_code: data,
      //   document_category: "LIST_B",
      // }).then((res) => {
      setListB(res?.data?.ListB?.document_types);
      // });
      // setLoader(true);
      // await ApiHelper.post(API.getI9DocTypes, {
      //   citizenship_status_code: data,
      //   document_category: "LIST_C",
      // }).then((res) => {
      setListC(res?.data?.ListC?.document_types);
      setLoader(false);
    });
  };

  const fetchAllCases = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      userid: user?.id,
      page_size: 30,
      page_number: pageNo,
      sort_direction: "DESC",
    };
    if (filterCompany !== null) {
      obj.companyid = filterCompany;
    }
    await ApiHelper.post(API.listCases, obj)
      .then((resData) => {
        if (resData.status === 200) {
          console.log(resData);
          setCases(resData?.data?.results);
          getCandidateData(resData?.data?.results[0]?.case_number);
          setUsersLength(resData?.data?.results?.length);
          setTotalCount(resData?.data?.total_results);
          setCompany(resData?.data?.Companies);
          if (resData?.data?.pagination?.is_last_page === false) {
            setPageNo(resData?.data?.pagination?.next_page);
          }
          //   setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const fetchMoreData = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));

    const obj = {
      userid: user?.id,
      page_size: 30,
      page_number: pageNo,
      sort_direction: "DESC",
    };
    if (filterCompany !== null) {
      obj.companyid = filterCompany;
    }
    await ApiHelper.post(API.listCases, obj)
      .then((resData) => {
        console.log(resData);
        setUsersLength(resData?.data?.results?.length);
        setTotalCount(resData?.data?.total_results);
        setCompany(resData?.data?.Companies);
        const array = cases.concat(resData.data.results);
        if (resData?.data?.pagination?.is_last_page === false) {
          setPageNo(resData?.data?.pagination?.next_page);
        }
        setCases(array);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  async function getCandidateData(id) {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      caseId: id,
    };
    await ApiHelper.post(API.caseDetails, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.status === 200) {
          setCaseDetails(resData?.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }

  const getAvatar = (name) => {
    const fullName = name; // Replace with the full name you want to extract initials from

    // Split the full name into words
    const nameParts = fullName?.split(" ");

    let firstNameInitial = "";
    let lastNameInitial = "";

    // Check if there is at least one name part
    if (nameParts.length > 0) {
      // Extract the first letter of the first name
      firstNameInitial = nameParts[0].charAt(0).toUpperCase();

      // Check if there is at least one more name part (last name or middle name)
      if (nameParts.length > 1) {
        // Extract the first letter of the last name
        lastNameInitial = nameParts[nameParts.length - 1]
          .charAt(0)
          .toUpperCase();
      } else if (nameParts[0].length > 1) {
        // If there's only one name part and it has more than one letter, take the first two letters as first name initials
        firstNameInitial = nameParts[0].substring(0, 2).toUpperCase();
      }
    }

    // console.log(`First Name Initial: ${firstNameInitial}`);
    // console.log(`Last Name Initial: ${lastNameInitial}`);
    if (firstNameInitial !== "" && lastNameInitial !== "") {
      return <p>{firstNameInitial + lastNameInitial}</p>;
    } else {
      return <p>{firstNameInitial}</p>;
    }
  };

  const getDocName = (list, value) => {
    console.log(listB, listC, list, value);
    let obj = {};
    if (list === "LIST_B") {
      obj = listB?.filter((item) => item?.code === value);
    } else {
      obj = listC?.filter((item) => item?.code === value);
    }
    console.log(obj);
    if (
      obj === undefined ||
      obj[0]?.name === null ||
      obj[0]?.name === undefined
    ) {
      return "";
    } else if (obj[0]?.name === "N/A") {
      return "";
    } else return obj[0]?.name;
  };

  return (
    <div className="sidebar_open fixed-side" style={{ overflowY: "hidden" }}>
      <div className=" mt-2">
        <div className="col-md-12 ">
          <div class="row d-flex align-items-center">
            <div class="team-member onbording-name-div col-md-8">
              <li className="list-group-item same-line">
                <div className="filterAlign">
                  <div className="row">
                    {company.length !== 0 && (
                      <div className="col-sm-3 col-lg-3">
                        <div className="main-filter">
                          {/*<p className="filter-name">Company :</p>*/}
                          <select
                            class="form-select drop-filter customFilt"
                            value={filterCompany}
                            onChange={(e) => {
                              setPageNo(1);
                              setFilterCompany(e.target.value);
                            }}
                          >
                            {company?.map((item) => {
                              return (
                                <option value={item.id}>
                                  {" "}
                                  {item.company_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </li>
            </div>
            {/* 
            <div class="search serach-width-div col-md-4">
              <div class="searchere mb-0 serach-div">
              <img
                      src={Serachg}
                      alt="test"
                      className="menu_icon search"
                    />
                    <input
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                      value={searchText}
                      className="form-control border-0"
                      placeholder="Search...."
                    ></input>



              </div>
              </div> */}
          </div>

          <iframe
            id="pdfViewer"
            width="100%"
            height="600px"
            style={{ border: "1px solid #ccc", display: "none" }}
          />
        </div>

        <div className="col-md-12 mt-3">
          <div className="row">
            <div className="cand-outer col-md-4 col-lg-4">
              <div className="can-lists p-3">
                <div className="d-flex userlist m_3x">
                  <div
                    className="justify-content-between"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div className="hd-can pl-3">
                      <h4 className="allTxt">All</h4>
                      <div>
                        <span className="count-ca">
                          <p className="count-number">{totalCount}</p>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div id="us-scroll" className="candScroll scrlHe-tab scroll1">
                    {cases?.length !== 0 ? (
                      <ul>
                        <InfiniteScroll
                          dataLength={
                            cases?.length === undefined ? 0 : cases?.length
                          }
                          next={() => {
                            console.log("reached");
                            usersLength === 30 && fetchMoreData();
                          }}
                          style={{ display: "flex", flexDirection: "column" }}
                          hasMore={usersLength === 30 ? true : false}
                          loader={
                            <div className="ca-details">
                              <span className="lastChld">Loading..</span>
                            </div>
                          }
                          endMessage={
                            <div className="ca-details">
                              <span className="lastChld">
                                Yay! You have seen it all
                              </span>
                            </div>
                          }
                          scrollableTarget="us-scroll"
                        >
                          {cases?.map((item, index) => {
                            const roundedScore =
                              typeof item?.score === "number"
                                ? Math.ceil(item?.score * 10) / 10
                                : item?.score;
                            return (
                              <li className="user-itm">
                                <a
                                  className={
                                    caseDetails?.case_number ===
                                    item?.case_number
                                      ? "candidate newDes active"
                                      : "candidate newDes"
                                  }
                                >
                                  <div className="us-lists-itm d-flex align-items-center">
                                    {/* <div className="form-check me-3 ms-2 ps-0">
                                        <input type="checkbox" onChange={() => handleCheckboxChange(item.id)} checked={candidateIdList.includes(String(item.id))} name="check1" value="check" />
                                    </div> */}
                                    <div
                                      className="d-flex wrp align-items-center"
                                      onClick={() => {
                                        getCandidateData(item?.case_number);
                                        setIndex(index);
                                        setRsTab(true);
                                      }}
                                    >
                                      <div
                                        className="avatar"
                                        style={{ backgroundColor: "#41D1FF" }}
                                      >
                                        {getAvatar(
                                          item?.first_name +
                                            " " +
                                            item?.last_name
                                        )}
                                      </div>
                                      <div className="profie-width">
                                        <div className="ca-details">
                                          <h3>
                                            {item?.first_name +
                                              " " +
                                              item?.last_name}
                                          </h3>
                                          <span>
                                            {item?.case_status === "CLOSED" &&
                                            item?.case_eligibility_statement ===
                                              "EMPLOYMENT_AUTHORIZED"
                                              ? "EMPLOYMENT AUTHORIZED"
                                              : item?.case_status ===
                                                  "CLOSED" &&
                                                item?.case_eligibility_statement ===
                                                  "NO_ACTION_FNC"
                                              ? "FINAL NONCONFIRMATION"
                                              : item?.case_status ===
                                                  "CLOSED" &&
                                                item?.case_eligibility_statement ===
                                                  "NOT_AUTHORIZED_EMPLOYMENT"
                                              ? "FINAL NONCONFIRMATION"
                                              : item?.case_status ===
                                                  "CLOSED" &&
                                                item?.case_eligibility_statement ===
                                                  "RESUBMIT_CASE"
                                              ? "CLOSED CASE AND RESUBMIT"
                                              : item?.case_status ===
                                                  "CLOSE_CASE_AND_RESUBMIT" &&
                                                item?.case_eligibility_statement ===
                                                  "RESUBMIT_CASE"
                                              ? "CLOSED CASE AND RESUBMIT"
                                              : item?.case_status ===
                                                  "CLOSED" &&
                                                item?.case_eligibility_statement ===
                                                  null
                                              ? item?.case_status_display.toUpperCase()
                                              : item?.case_status ===
                                                "MANUAL_REVIEW"
                                              ? item?.case_status_display.toUpperCase()
                                              : item?.case_status ===
                                                "PHOTO_MATCH"
                                              ? item?.case_status_display.toUpperCase()
                                              : item?.case_status ===
                                                "PENDING_REFERRAL"
                                              ? item?.case_status_display.toUpperCase()
                                              : item?.case_status === "REFERRED"
                                              ? item?.case_status_display.toUpperCase()
                                              : item?.case_status === "QUEUED"
                                              ? item?.case_status_display.toUpperCase()
                                              : item?.case_status === "DRAFT"
                                              ? item?.case_status_display.toUpperCase()
                                              : item?.case_status ===
                                                "FINAL_NONCONFIRMATION"
                                              ? item?.case_status_display.toUpperCase()
                                              : item?.case_status ===
                                                "SCAN_AND_UPLOAD"
                                              ? item?.case_status_display.toUpperCase()
                                              : item?.case_status ===
                                                "UNCONFIRMED_DATA"
                                              ? item?.case_status_display.toUpperCase()
                                              : ""}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <span className="new-spans ml-2">
                                      <span className="open-final-bg-list">
                                        {item?.case_status === "CLOSED"
                                          ? "CLOSED"
                                          : "OPEN"}
                                      </span>
                                    </span>
                                  </div>
                                </a>
                              </li>
                            );
                          })}
                        </InfiniteScroll>
                      </ul>
                    ) : (
                      <h4 className="mx-2 my-4 lastChld">
                        Candidate Not Found
                      </h4>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {cases.length !== 0 && caseDetails?.case_number !== undefined && (
              <div
                className={
                  rsTab === true
                    ? "col-md-8 col-lg-8 candPads active"
                    : "col-md-8 col-lg-8 candPads"
                }
              >
                <div className="d-flex detail-user blueBorder p-0">
                  <div className="alignTops e-verify mb-0 p-3">
                    <div className="llbw m-0">
                      <div className="candidate">
                        <div className="d-flex wrp align-items-center">
                          <div
                            className="avatar"
                            style={{
                              backgroundColor: "#41D1FF",
                            }}
                          >
                            <span>
                              {getAvatar(
                                caseDetails?.first_name +
                                  " " +
                                  caseDetails?.last_name
                              )}
                            </span>
                          </div>
                          <div className="ca-details">
                            <h3>
                              {caseDetails.first_name +
                                " " +
                                caseDetails?.last_name}
                            </h3>
                            {/*<span className="styDiv">{caseDetails.email}</span>*/}
                            <a className="call-text styDiv">
                              {caseDetails?.case_status === "CLOSED"
                                ? "CLOSED"
                                : "OPEN"}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center  m-0">
                      {/* <button className="submits-btn rounded p-2 sub-bttn-right-sides-download-ev">Check Status</button> */}
                      <button
                        className="submits-btn rounded p-2 sub-bttn-right-sides-ev"
                        onClick={() => {
                          navigate(
                            "/dashboard/review/" +
                              caseDetails?.interviewee_id +
                              "/" +
                              caseDetails?.case_number
                          );
                        }}
                      >
                        {caseDetails?.case_status === "CLOSED"
                          ? "View Case"
                          : "Continue Case"}
                      </button>
                    </div>
                  </div>

                  <div className="tble-everify">
                    <div className="tableFixHead">
                      {/* <table class="table">
    <thead>
      <tr>
        <th>Case Number</th>
        <th>Date of Case Creation</th>
        <th>First Day of Employment </th>
        <th>Client Company</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>2024253115501JC</td>
        <td>Sep 09, 2024, 1:25pm</td>
        <td>Sep 06, 2024</td>
        <td>Nelson</td>
      </tr>
     </tbody>
     </table>


     <table class="table">
       <thead>
      <tr>
        <th>Citizenship Status </th>
        <th>Date of Birth</th>
        <th> U.S. Social Sec </th>
        <th>Case Created By</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>U.S. Citizen</td>
        <td>May 21, 2024</td>
        <td>** ** 4587</td>
        <td>KKIM6833 (Nelson NEWTON)</td>
      </tr>
     </tbody>
     </table>

     <table class="table">
      <thead>
      <tr>
        <th> List B Document</th>
        <th>Document Number </th>
        <th>State </th>
        <th>Document Expiration</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Driver's license or ID card issued by a U.S. state or outlying possession</td>
        <td> 6790543</td>
        <td>FL</td>
        <td>Sep 19, 2024 </td>
      </tr>
     </tbody>
  </table>*/}

                      <div className="">
                        <div className="row">
                          <div className="col-12">
                            <div className="">
                              <span className="everify-head">Case Status</span>
                              <p className="everify-head-para mt-2">
                                {caseDetails?.case_status === "CLOSED" &&
                                caseDetails?.case_eligibility_statement ===
                                  "EMPLOYMENT_AUTHORIZED" ? (
                                  <span className="employment-text-bg ">
                                    EMPLOYMENT AUTHORIZED
                                  </span>
                                ) : caseDetails?.case_status === "CLOSED" &&
                                  caseDetails?.case_eligibility_statement ===
                                    "NO_ACTION_FNC" ? (
                                  <span className="Final-text-bg ">
                                    FINAL NONCONFIRMATION
                                  </span>
                                ) : caseDetails?.case_status === "CLOSED" &&
                                  caseDetails?.case_eligibility_statement ===
                                    "NOT_AUTHORIZED_EMPLOYMENT" ? (
                                  <span className="Final-text-bg ">
                                    FINAL NONCONFIRMATION
                                  </span>
                                ) : caseDetails?.case_status === "CLOSED" &&
                                  caseDetails?.case_eligibility_statement ===
                                    "RESUBMIT_CASE" ? (
                                  <span className="Resubmit-text-bg ">
                                    CLOSED CASE AND RESUBMIT
                                  </span>
                                ) : caseDetails?.case_status ===
                                    "CLOSE_CASE_AND_RESUBMIT" &&
                                  caseDetails?.case_eligibility_statement ===
                                    "RESUBMIT_CASE" ? (
                                  <span className="Resubmit-text-bg ">
                                    CLOSED CASE AND RESUBMIT
                                  </span>
                                ) : caseDetails?.case_status === "CLOSED" &&
                                  caseDetails?.case_eligibility_statement ===
                                    null ? (
                                  <span className="Final-text-bg ">
                                    {caseDetails?.case_status_display.toUpperCase()}
                                  </span>
                                ) : caseDetails?.case_status ===
                                  "MANUAL_REVIEW" ? (
                                  <span className="emp-dhs-bg">
                                    {caseDetails?.case_status_display.toUpperCase()}
                                  </span>
                                ) : caseDetails?.case_status ===
                                  "PHOTO_MATCH" ? (
                                  <span className="emp-dhs-bg">
                                    {caseDetails?.case_status_display.toUpperCase()}
                                  </span>
                                ) : caseDetails?.case_status ===
                                  "PENDING_REFERRAL" ? (
                                  <span className="tent-non-bg">
                                    {caseDetails?.case_status_display.toUpperCase()}
                                  </span>
                                ) : caseDetails?.case_status === "REFERRED" ? (
                                  <span className="emp-dhs-bg">
                                    {caseDetails?.case_status_display.toUpperCase()}
                                  </span>
                                ) : caseDetails?.case_status === "QUEUED" ? (
                                  <span className="emp-dhs-bg">
                                    {caseDetails?.case_status_display.toUpperCase()}
                                  </span>
                                ) : caseDetails?.case_status === "DRAFT" ? (
                                  <span className="case-incom">
                                    {caseDetails?.case_status_display.toUpperCase()}
                                  </span>
                                ) : caseDetails?.case_status ===
                                  "FINAL_NONCONFIRMATION" ? (
                                  <span className="Final-text-bg ">
                                    {caseDetails?.case_status_display.toUpperCase()}
                                  </span>
                                ) : caseDetails?.case_status ===
                                  "UNCONFIRMED_DATA" ? (
                                  <span className="case-incom">
                                    {caseDetails?.case_status_display.toUpperCase()}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div class="col-12">
                            <div className="everify-column">
                              <span className="everify-head">Case Number</span>
                              <p className="everify-head-para">
                                {caseDetails?.case_number}
                              </p>
                            </div>
                            <div className="everify-column">
                              <span className="everify-head">
                                Date of Case Creation
                              </span>
                              <p className="everify-head-para">
                                {moment(cases[index]?.created_date).format(
                                  "MMMM D, YYYY"
                                )}
                              </p>
                            </div>
                            <div className="everify-column">
                              <span className="everify-head">
                                First Day of Employment
                              </span>
                              <p className="everify-head-para">
                                {" "}
                                {moment(caseDetails?.date_of_hire).format(
                                  "MMMM D, YYYY"
                                )}
                              </p>
                            </div>
                            <div className="everify-column">
                              <span className="everify-head">
                                Client Company
                              </span>
                              <p className="everify-head-para">
                                {" "}
                                {caseDetails?.case_creator_name}
                              </p>
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="everify-column">
                              <span className="everify-head">
                                {" "}
                                Citizenship Status
                              </span>
                              <p className="everify-head-para">
                                {caseDetails?.citizenship_status_code ===
                                "US_CITIZEN"
                                  ? "A citizen of the United States"
                                  : caseDetails?.citizenship_status_code ===
                                    "NONCITIZEN"
                                  ? "A noncitizen national of the United States"
                                  : caseDetails?.citizenship_status_code ===
                                    "LAWFUL_PERMANENT_RESIDENT"
                                  ? "A lawful permanent resident"
                                  : caseDetails?.citizenship_status_code ===
                                    "NONCITIZEN_AUTHORIZED_TO_WORK"
                                  ? "A noncitizen authorized to work until (exp. date, if any)"
                                  : null}
                              </p>
                            </div>
                            <div className="everify-column">
                              <span className="everify-head">
                                Date of Birth{" "}
                              </span>
                              <p className="everify-head-para">
                                {moment(caseDetails?.date_of_birth).format(
                                  "MMMM D, YYYY"
                                )}
                              </p>
                            </div>
                            <div className="everify-column">
                              <span className="everify-head">
                                U.S. Social Sec. Number
                              </span>
                              <p className="everify-head-para">
                                ** ** {caseDetails?.ssn.slice(-4)}
                              </p>
                            </div>
                            <div className="everify-column">
                              <span className="everify-head">
                                {" "}
                                Case Created By
                              </span>
                              <p className="everify-head-para">
                                {caseDetails?.client_company_id}(
                                {caseDetails?.case_creator_name})
                              </p>
                            </div>
                          </div>
                          {caseDetails?.document_a_type_code !== null ? (
                            <>
                              {caseDetails?.document_a_type_code ===
                                "US_PASSPORT" && (
                                <div className="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      List A Document
                                    </span>
                                    <p className="everify-head-para">
                                      U.S. Passport or Passport Card
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Document Number{" "}
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.us_passport_number}
                                    </p>
                                  </div>
                                  {/* <div className="everify-column">
        <span className="everify-head">Issuing Authority</span>
          <p className="everify-head-para">FL</p>
        </div> */}
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      {" "}
                                      Document Expiration
                                    </span>
                                    <p className="everify-head-para">
                                      {moment(
                                        caseDetails?.expiration_date
                                      ).format("MMMM D, YYYY")}{" "}
                                    </p>
                                  </div>
                                </div>
                              )}
                              {caseDetails?.document_a_type_code ===
                                "FORM_I94_RECEIPT" && (
                                <div className="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      List A Document
                                    </span>
                                    <p className="everify-head-para">
                                      Arrival/Departure Record (Form I-94) with
                                      temporary I-551 stamp or refugee admission
                                      stamp (receipt)
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      {" "}
                                      Document Expiration
                                    </span>
                                    <p className="everify-head-para">
                                      {moment(
                                        caseDetails?.expiration_date
                                      ).format("MMMM D, YYYY")}{" "}
                                    </p>
                                  </div>
                                </div>
                              )}
                              {caseDetails?.document_a_type_code ===
                                "FORM_I551" && (
                                <div className="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      List A Document
                                    </span>
                                    <p className="everify-head-para">
                                      Permanent Resident Card or Alien
                                      Registration Receipt Card (Form I-551)
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Document Number{" "}
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.i551_number}
                                    </p>
                                  </div>
                                </div>
                              )}
                              {caseDetails?.document_a_type_code ===
                                "FOREIGN_PASSPORT_WITH_I551_STAMP" && (
                                <div className="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      List A Document
                                    </span>
                                    <p className="everify-head-para">
                                      Foreign passport with temporary I-551
                                      stamp or printed notation on a MRIV
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Document Number{" "}
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.foreign_passport_number}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      {" "}
                                      Document Expiration
                                    </span>
                                    <p className="everify-head-para">
                                      {moment(
                                        caseDetails?.expiration_date
                                      ).format("MMMM D, YYYY")}{" "}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      {" "}
                                      Country of Issuance
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.country_code}{" "}
                                    </p>
                                  </div>
                                </div>
                              )}

                              {caseDetails?.document_a_type_code ===
                                "FORM_I766" && (
                                <div className="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      List A Document
                                    </span>
                                    <p className="everify-head-para">
                                      Employment Authorization Document (Form
                                      I-766)
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Document Number{" "}
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.i766_number}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      {" "}
                                      Document Expiration
                                    </span>
                                    <p className="everify-head-para">
                                      {moment(
                                        caseDetails?.expiration_date
                                      ).format("MMMM D, YYYY")}{" "}
                                    </p>
                                  </div>
                                </div>
                              )}
                              {caseDetails?.document_a_type_code ===
                                "FOREIGN_PASSPORT_WITH_FORM_I94" && (
                                <div className="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      List A Document
                                    </span>
                                    <p className="everify-head-para">
                                      Foreign passport with Arrival/Departure
                                      Record (Form I-94)
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Document Number{" "}
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.foreign_passport_number}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Issuing Authority
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.country_code}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              {caseDetails?.document_b_type_code ===
                                "DRIVERS_LICENSE" && (
                                <div className="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      List B Document
                                    </span>
                                    <p className="everify-head-para">
                                      Driver's license or ID card issued by a
                                      U.S. state or outlying possession
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Document Number{" "}
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.document_bc_number}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">State</span>
                                    <p className="everify-head-para">
                                      {caseDetails?.us_state_code}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      {" "}
                                      Document Expiration
                                    </span>
                                    <p className="everify-head-para">
                                      {moment(
                                        caseDetails?.expiration_date
                                      ).format("MMMM D, YYYY")}{" "}
                                    </p>
                                  </div>
                                </div>
                              )}
                              {caseDetails?.document_b_type_code !==
                                "DRIVERS_LICENSE" && (
                                <div className="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      List B Document
                                    </span>
                                    <p className="everify-head-para">
                                      {loader === false &&
                                        getDocName(
                                          "LIST_B",
                                          caseDetails?.document_b_type_code
                                        )}
                                    </p>
                                  </div>
                                </div>
                              )}

                              <div className="col-12">
                                <div className="everify-column">
                                  <span className="everify-head">
                                    List C Document
                                  </span>
                                  <p className="everify-head-para">
                                    {loader === false &&
                                      getDocName(
                                        "LIST_C",
                                        caseDetails?.document_c_type_code
                                      )}
                                  </p>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* for showing toast */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {loader && <Spinner />}
      {miniLoader && <MiniSpinner />}
    </div>
  );
};

export default Everify;
